/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_AlwaysInputs */



/**
* | output |
* | --- |
* | "Always" |
*
* @param {Options_Editor_Speaker_Assignment_AlwaysInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_always = /** @type {((inputs?: Options_Editor_Speaker_Assignment_AlwaysInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_AlwaysInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toujours")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stets")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sempre")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всегда")
	if (locale === "es") return /** @type {LocalizedString} */ ("Siempre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总是")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いつも")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हमेशा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sempre")
	return /** @type {LocalizedString} */ ("Always")
});